export default "__VITE_ASSET__BbRiy1wq__"